export default "__VITE_ASSET__DuBVEl86__"